import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__login",
  "use": "icon__login-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon__login\"><title>Shape</title><path d=\"M22.001 24H9.996a2.001 2.001 0 0 1-1.999-2v-5a1 1 0 1 1 1.999 0v5h12.005V2H9.996v5a1 1 0 0 1-1.999 0V2c0-1.103.896-2 1.999-2h12.005c1.103 0 2 .897 2 2v20c0 1.103-.897 2-2 2zM12.288 8.707a1 1 0 0 1 1.414-1.414l3.998 3.999a1.001 1.001 0 0 1 0 1.415l-3.998 4a.999.999 0 1 1-1.414-1.414L14.58 13H.999a1 1 0 0 1 0-2H14.58l-2.292-2.293z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol